import { QueryClient } from '@tanstack/react-query';
import { QUERY_STALE_TIME, QUERY_RETRY } from '../constants';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: QUERY_RETRY,
      staleTime: QUERY_STALE_TIME,
    },
  },
});
